// 调账

import { HttpAdjustPayAccountList } from '@/service/chargescalc';
import { HttpServiceWarehouseList } from "@/service/basicdata"
import TableList from "@components/templates/tablelist";
import compUpdate from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            warehouseList: []
        };
    },
    created() {
        HttpServiceWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.title})`
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        interceptRequest(params) {
            const { BT_periodDate } = params.search;
            params.periodDate = this.handleDateFormat(BT_periodDate, 'yyyy-mm');

            delete params.search.BT_periodDate;
            this.formData = params
            return params
        },
        ajaxRequest: HttpAdjustPayAccountList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t('fbb.adjustment.add', { defaultValue: "添加调账" }),
                        show: true,
                        width: 'middle',
                        component: "compUpdate",
                        showFooter: false,
                    }
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/adjustmantPayable/export", this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data', { defaultValue: "导入数据" }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/adjustmantPayable/upload",
                        name: "file",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/adjustmantPayable/downloadTemplate", {}, {
                                executor: 'download',
                                type: 'url',
                                method: 'post',
                            });
                        }
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name:  this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                },
                {
                    name: this.$t('global.common.import', { defaultValue: "导入" }),
                    operate: "upload",
                    theme: "success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                // {
                //     label: "仓库",
                //     key: 'EQ_warehouseId',
                //     show: true,
                //     tag: 'vSelect',
                //     options: this.getBillcusWareList,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "仓库",
                    tag: "vSelect",
                    key: "EQ_warehouseId",
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: '账期',
                    tag: 'DatePicker',
                    key: 'BT_periodDate',
                    style: "width:180px",
                    props:{
                        type: 'month',
                        confirm:false,
                    },
                },
                {
                    label:  this.$t('fbb.adjustment.type', { defaultValue: '调账类型' }),
                    key: 'EQ_type',
                    tag: 'vSelect',
                    options: this.getAdjutmentType
                },
                // {
                //     label: '账单类型',
                //     tag: 'vSelect',
                //     key: 'EQ_billType',
				// 	options: [
                //         { value: 0, label: '库内作业'},
                //         { value: 1, label: '尾程'},
                //     ],
                // },
                {
                    label:  this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' }),
                    key: 'EQ_billingType',
                    tag: 'vSelect',
                    options: this.getCostType,
                },
                {
                    label: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
                    key: 'EQ_billingOrderNo',
                    tag: 'Input',
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'billNo',
                },
                // {
                //     title: '账单类型',
                //     key: 'billType',
                //     render: (h, { row }) => {
                //         return <div>{row.billType == 0 ? '库内作业' : row.billType == 1 ? '尾程' : '--'}</div>
                //     }
                // },
                {
                    title: "仓库",
                    render: (h, { row }) =>{
                        // this.findRenderLabel(
                        //     this.getBillcusWareList,
                        //     row.warehouseId
                        // )
                        // const result= this.warehouseList.filter(item => item.attach.code === row.warehouseCode )[0]
                        return <div>{row.warehouseCode ? row.warehouseCode : '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.billmanage.bill_date', { defaultValue: '月份' }),
                    key: 'month',
                },
                {
                    title: this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' }),
                    key: 'billingType',
                    render: (h, { row }) => this.findRenderLabel(this.getCostType, row.billingType) || '--'
                },
                {
                    title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
                    key: 'billingOrderNo',
                    render: (h, { row }) =>{
                        return <div>{row.billingOrderNo ? row.billingOrderNo : '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.adjustment.type', { defaultValue: '调账类型' }),
                    key: 'type',
                    render: (h, { row }) => this.findRenderLabel(this.getAdjutmentType, row.type)||'--'
                },
                {
                    title: this.$t('fbb.adjustment.amount', { defaultValue: '调账金额' }),
                    key: 'amount',
                    render: (h, { row }) =>{
                        return <div>{row.amount ? row.amount : '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    key: 'organizationName',
                    render: (h, { row }) =>{
                        return <div>{row.organizationName ? row.organizationName : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.currency', { defaultValue: '币种' }),
                    key: 'currency',
                    render: (h, { row }) =>{
                        return <div>{row.currency ? row.currency : '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.adjustment.remark', { defaultValue: '调账说明' }),
                    key: 'remark',
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }];
        },
    },
};




